var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('div',{staticClass:"bread"},[_c('router-link',{attrs:{"to":{ name: 'Index' }}},[_vm._v("首页")]),_c('span',{staticClass:"slash"},[_vm._v("/")]),_c('span',{staticClass:"current"},[_vm._v(_vm._s(_vm.$route.query.title))])],1),_c('Classify',{attrs:{"items":[
      {
        id: 'classify',
        name: '分类',
        value: { item: _vm.search.classify_id },
        children: _vm.classifyList,
      },
    ]},on:{"change":_vm.onClassifyChange}}),_c('list',{ref:"list",staticClass:"list",attrs:{"url":"/api/app/information/index","method":"post","search":_vm.search},scopedSlots:_vm._u([{key:"default",fn:function({ list }){return [_c('div',_vm._l((list),function(item){return _c('NewsRecommendItem',{key:item.id,staticClass:"news-recommend-item",attrs:{"item":item}})}),1),(list.length == 0)?_c('Empty',{staticClass:"empty",attrs:{"title":"暂无资讯"}}):_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }